import { OpArgType } from '@memoraiz/api-client';
import { SdkResource } from './common';

export const attempt = SdkResource.from((client) => ({
  create: (data: OpArgType<'/widgets/attempts', 'post'>) =>
    client
      .POST('/widgets/attempts', { body: data })
      .then(({ data: response }) => {
        if (!response) {
          throw new Error('Invalid response');
        }
        return response.data;
      }),
  update: (id: string, data: OpArgType<'/widgets/attempts/{id}', 'post'>) =>
    client
      .POST('/widgets/attempts/{id}', { body: data, params: { path: { id } } })
      .then(({ data: response }) => {
        if (!response) {
          throw new Error('Invalid response');
        }
        return response.data;
      }),
}));
